import {
  SET_STEP,
  ADD_TO_MULTI_FORM,
  REMOVE_FROM_MULTI_FORM,
  CLEAR_MULTI_FORM,
  SUBMIT_MULTI_FORM_START,
  SUBMIT_MULTI_FORM_SUCCESS,
  SUBMIT_MULTI_FORM_FAIL,
  SET_FORM,
  CLEAR_FORM
} from './action-types';
import initialState from './initial-state';
import { FORM_SUBMIT_STATUS } from '../../constants/common';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FORM: {
      const { form } = action.payload;
      return {
        ...state,
        form
      };
    }
    case CLEAR_FORM: {
      return {
        ...state,
        form: {}
      };
    }
    case SET_STEP: {
      const { step } = action.payload;
      return {
        ...state,
        step: Number.parseInt(step)
      };
    }
    case ADD_TO_MULTI_FORM: {
      const { id, form } = action.payload;
      const multiForm = { ...state.multiForm, [id]: form };
      return {
        ...state,
        multiForm
      };
    }
    case REMOVE_FROM_MULTI_FORM: {
      const { id } = action.payload;
      const multiForm = { ...state.multiForm };
      delete multiForm[id];
      return {
        ...state,
        multiForm
      };
    }
    case CLEAR_MULTI_FORM: {
      return {
        ...state,
        multiForm: {}
      };
    }
    case SUBMIT_MULTI_FORM_START: {
      const { id, form } = action.payload;

      return {
        ...state,
        multiForm: {
          ...state.multiForm,
          [id]: {
            ...form,
            SUBMIT_STATUS: FORM_SUBMIT_STATUS.SUBMITTING
          }
        }
      };
    }
    case SUBMIT_MULTI_FORM_SUCCESS: {
      const { id, form } = action.payload;

      return {
        ...state,
        multiForm: {
          ...state.multiForm,
          [id]: {
            ...form,
            SUBMIT_STATUS: FORM_SUBMIT_STATUS.SUCCESS
          }
        }
      };
    }
    case SUBMIT_MULTI_FORM_FAIL: {
      const { id, form } = action.payload;

      return {
        ...state,
        multiForm: {
          ...state.multiForm,
          [id]: {
            ...form,
            SUBMIT_STATUS: FORM_SUBMIT_STATUS.FAIL
          }
        }
      };
    }
    default:
      return state;
  }
};
